import { render } from "./TradingViewChart.vue?vue&type=template&id=9ca3c60c&scoped=true"
import script from "./TradingViewChart.vue?vue&type=script&lang=js"
export * from "./TradingViewChart.vue?vue&type=script&lang=js"

import "./TradingViewChart.vue?vue&type=style&index=0&id=9ca3c60c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ca3c60c"]])

export default __exports__